/**
 * 短窗口请求去重（inflight 合并）。
 *
 * 背景：dashboard 首屏有多个互不相识的组件各自请求同一批「账号级」接口 ——
 * AuthContext / 侧栏 Navigation / 侧栏 Equipment / 过期引导 / 过期遮罩 /
 * dashboard 卡片 / ExpirationReminder，同一时刻会重复发出多条完全相同的请求。
 *
 * 做法：相同 key 的请求在「尚未返回」期间复用同一个 Promise；
 * 请求一结束（无论成功或失败）立即释放，**不缓存结果**。
 * 因此不会出现「绑定设备 / 续费成功后读到旧数据」的问题 —— 下一个调用一定会重新发请求。
 *
 * @param {string} key 去重键；不同查询参数必须是不同 key，否则会串数据
 * @param {() => Promise<any>} factory 真正的请求
 * @returns {Promise<any>}
 */
const inflight = new Map()

export const dedupeRequest = (key, factory) => {
  if (!key) return factory()

  const pending = inflight.get(key)
  if (pending) return pending

  let promise

  try {
    promise = Promise.resolve(factory())
  } catch (error) {
    return Promise.reject(error)
  }

  // 结束后立刻释放：保证下一个调用拿到的是新鲜数据
  promise = promise.finally(() => {
    if (inflight.get(key) === promise) inflight.delete(key)
  })

  inflight.set(key, promise)

  return promise
}

/** 仅供调试：清空去重表 */
export const clearInflightRequests = () => inflight.clear()

export default dedupeRequest
